import React, { useMemo } from 'react';
import useStore from '../store';
import { formatCurrency } from '../utils/colors';

function StatsBar() {
  const { graphData } = useStore();
  
  const stats = useMemo(() => {
    if (!graphData || !graphData.nodes) {
      return {
        totalBids: 0,
        totalValue: 0,
        activeAgencies: 0,
        avgValue: 0
      };
    }
    
    const nodes = graphData.nodes;
    const totalBids = nodes.length;
    const totalValue = nodes.reduce((sum, node) => sum + (node.value || 0), 0);
    const agencies = new Set(nodes.map(n => n.agency));
    const avgValue = totalBids > 0 ? totalValue / totalBids : 0;
    
    return {
      totalBids,
      totalValue,
      activeAgencies: agencies.size,
      avgValue
    };
  }, [graphData]);
  
  return (
    <div className="stats-bar">
      <div className="stat-item">
        <div className="stat-value">{stats.totalBids}</div>
        <div className="stat-label">ACTIVE BIDS</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div className="stat-value">{formatCurrency(stats.totalValue)}</div>
        <div className="stat-label">TOTAL VALUE</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div className="stat-value">{stats.activeAgencies}</div>
        <div className="stat-label">ACTIVE AGENCIES</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div className="stat-value">{formatCurrency(stats.avgValue)}</div>
        <div className="stat-label">AVG VALUE</div>
      </div>
    </div>
  );
}

export default StatsBar;